import { PATHS } from '@/app/router/paths'
import { AuthLayout, AuthLegalFooter, RustWordmark } from './AuthLayout'
import { RegisterForm } from './AuthForms'

export default function ClientRegisterPage() {
  return (
    <AuthLayout backTo={PATHS.role} backLabel="Terug naar rolkeuze">
      <RustWordmark width={140} />
      <h1 className="auth-headline" style={{ fontSize: 26 }}>
        Account aanmaken
      </h1>
      <p className="auth-subtitle">Maak een cliëntaccount om met RUST te beginnen.</p>
      <RegisterForm role="client" />
      <AuthLegalFooter />
    </AuthLayout>
  )
}
